/**
 * ScrollTrigger: one refresh after all pin sections have created their triggers.
 * Per GSAP docs: call ScrollTrigger.refresh() after you're done creating everything.
 * No script order dependency; new files in js/scripts are picked up by glob.
 */
(function() {
	'use strict';

	function run() {
		setTimeout(function() {
			if (typeof window.ScrollTrigger !== 'undefined') {
				window.ScrollTrigger.sort();
				window.ScrollTrigger.refresh(true);
			}
		}, 500);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
